import React from 'react';
import ReactModal from 'react-modal';
import { Heading, Subheading } from '../typography';
import Close from '../svg/Close';

type Props = {
  isOpen: boolean;
  heading: string;
  subheading?: string;
  children: React.ReactNode;
  onClose: () => void;
};

const Modal = ({ isOpen, onClose, heading, subheading, children }: Props) => {
  //This is needed so screen readers don't see main content when modal is opened.
  React.useEffect(() => {
    ReactModal.setAppElement('body');
  }, []);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={heading}
      htmlOpenClassName="overflow-hidden"
      overlayClassName={'z-20 flex fixed inset-0 justify-center items-center bg-black-100/50 lg:p-24'}
      className={
        'h-full max-h-full overflow-y-scroll bg-white-100 p-16 shadow-xl outline-none sm:p-32 lg:h-fit lg:max-w-3xl lg:rounded-28 lg:p-40 xl:max-w-5xl'
      }
    >
      <div className="mb-32 flex justify-between">
        <div className="mr-16">
          <Heading variant="xs">{heading}</Heading>
          {subheading && (
            <Subheading small classes={'mt-8 text-black-100'}>
              {subheading}
            </Subheading>
          )}
        </div>
        <button aria-label={'Close'} className="flex h-32 w-32 items-center justify-center" onClick={onClose}>
          <Close />
        </button>
      </div>
      {children}
    </ReactModal>
  );
};
export default Modal;
